export const getBlogPostPath = (slug) => `/blog/${encodeURIComponent(String(slug || '').trim())}`;

export const formatBlogDate = (value, { includeTime = false } = {}) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...(includeTime
      ? {
          hour: '2-digit',
          minute: '2-digit',
        }
      : {}),
  }).format(date);
};

export const splitBlogContent = (content) => {
  const normalized = String(content || '')
    .replace(/\r\n?/g, '\n')
    .trim();

  if (!normalized) {
    return [];
  }

  return normalized
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
};

export const parseBlogInlineFormatting = (text) => {
  const source = String(text || '');
  const segments = [];
  const pattern = /\*\*([^*\n]+)\*\*/g;
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(source)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ text: source.slice(lastIndex, match.index), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < source.length) {
    segments.push({ text: source.slice(lastIndex), bold: false });
  }

  return segments.length > 0 ? segments : [{ text: source, bold: false }];
};

export const stripBlogFormatting = (text) => String(text || '').replace(/\*\*([^*\n]+)\*\*/g, '$1');

export const resolveBlogExcerpt = (post) => {
  const excerpt = String(post?.excerpt || '').trim();
  if (excerpt) {
    return stripBlogFormatting(excerpt);
  }

  const content = stripBlogFormatting(post?.content).replace(/\s+/g, ' ').trim();
  if (content.length <= 180) {
    return content;
  }

  return `${content.slice(0, 177).trim()}...`;
};
